<canvas  #canvasElement id="canvas" class="w-full h-full absolute top-0">

</canvas>

